// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"726":"df3c3c96","843":"ac7cfe22","921":"2035aee7","935":"e20bc5d2"}[chunkId] + ".css";
};